import { SearchBarLarge, SearchBarSmall } from 'constants/componentsDimension';
import styled, { css } from 'styled-components';
import { Box, Group as MaestroGroup, palette, spacing } from '@landr/maestro';

export const Wrapper = styled(Box)<{
    isBottomRadiusZero: boolean;
}>`
    display: flex;
    position: relative;
    align-items: stretch;

    width: ${SearchBarLarge};

    ${({ theme }): string => theme.breakpoint('ml')`
        width: ${SearchBarSmall};
    `}

    max-width: 100%;

    background-color: ${palette('neutral.800')};
    border-radius: ${spacing('xl')};

    padding: ${spacing('xs')};

    ${({ isBottomRadiusZero }) =>
        isBottomRadiusZero &&
        css`
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        `}
`;

export const Group = styled(MaestroGroup)`
    align-items: stretch;
    width: 100%;
    padding-left: ${spacing('xxs')};
    padding-right: ${spacing('xxs')};
`;

export const IconItem = styled(MaestroGroup.Item)`
    align-self: start;
    height: ${spacing('xl')};
    margin-top: ${spacing('xxs')};
    margin-bottom: ${spacing('xxs')};
`;
